import { useEffect, useReducer, FC, useCallback, useState, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FETCH_VOTE_DATA_LIST_SUCCESS, FETCH_VOTE_DATA_LIST_REQUEST, FETCH_VOTE_DATA_LIST_FAILURE, UPDATE_VOTE_SUCCESS, UPDATE_VOTE_REQUEST, UPDATE_VOTE_FAILURE, requestVoteDataList, receiveVoteDataList, errorVoteDataList, resetVoteDataList, requestUpdateVote, receiveUpdateVote, errorUpdateVote, resetUpdateVote, requestGetNext, errorGetNext, receiveGetNext, GET_NEXT_SUCCESS, setVoteStatus, updateRequestFilter, updateCurrentVote, RESET_VOTE_DATA, resetVoteData, SET_CURRENT_VOTE, UPDATE_REQUEST_FILTER, requestCompetitions, errorCompetitions, receiveCompetitions, FETCH_COMPETITIONS_REQUEST, FETCH_COMPETITIONS_SUCCESS, FETCH_COMPETITIONS_FAILURE, RESET_UPDATE_VOTE, setPrevCrt, VOICE_SET, SET_PREV_CRITERIA, VOTE_END,  fetchNextVote, GET_NEXT_DATA_REQUEST, GET_NEXT_DATA_SUCCESS, GET_NEXT_DATA_FAILURE, fetchVotes, UPDATE_VOTE_DATA, updateVoteData, fetchUpdateVote } from "shared/actions/Vote/voteActions";
import VoteContext, { RequestFilterT, initialContext } from "shared/contexts/VoteContext";

  export const PROJECT_VOTE_STATUS = {
    end: 'end',
    continue: 'continue',
    inProgress: 'inProgress'
  }

  type PropsT = {
    children: any;
  }
  
  export const VoteProvider: FC<PropsT> = ({ children }) => {
    const {i18n} = useTranslation();
    const [disableRequest, setDisableRequest] = useState(false);
    const [disableNextRequest, setDisableNextRequest] = useState(false);
    const [disableNextVoteRequest, setDisableNextVoteRequest] = useState(false);
    const [voteOptions, dispatch] = useReducer((state: any, action: any) => {
      switch (action.type) {
        case FETCH_VOTE_DATA_LIST_SUCCESS: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_VOTE_DATA_LIST_FAILURE:{
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_VOTE_DATA_LIST_REQUEST: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_COMPETITIONS_REQUEST: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_COMPETITIONS_SUCCESS:{
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_COMPETITIONS_FAILURE: {
          return {
            ...state,
            ...action.payload,
          }
        }

        case UPDATE_VOTE_SUCCESS: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case UPDATE_VOTE_REQUEST: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case UPDATE_VOTE_FAILURE: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case RESET_UPDATE_VOTE: {
          return {
            ...state,
            ...action.payload
          }
        }
        case GET_NEXT_SUCCESS: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case GET_NEXT_DATA_REQUEST: {
          return {
            ...state,
            ...action.payload
          }
        }
        case GET_NEXT_DATA_SUCCESS: {
          return {
            ...state,
            ...action.payload
          }
        }
        case GET_NEXT_DATA_FAILURE: {
          return {
            ...state,
            ...action.payload
          }
        }
        case UPDATE_REQUEST_FILTER: {
          return {
            ...state,
            requestFilter: action.payload
          }
        }
        case SET_CURRENT_VOTE: {
          return {
            ...state,
            ...action.payload
          }
        }
        case RESET_VOTE_DATA: {
          return {initialContext}
        }
        case UPDATE_VOTE_DATA: {
          return {
            ...state,
            requestFilter: undefined,
            currentList: [],
          }
        }
        case VOICE_SET: {
          return {
            ...state,
            voiceSet: action.payload
          }
        }
        case SET_PREV_CRITERIA: {
          return {
            ...state,
            ...action.payload
          }
        }
        case VOTE_END: {
          return { 
            ...state,
            ...action.payload
          }
        }
        default:
          return state;
      }
    }
      ,{...initialContext});

    const requestOpt = (additionalOpt: (val: boolean) => void) => ({ callback: additionalOpt, dispatch })

    const isCanFetchVotes = useMemo(
      () => (voteOptions?.requestFilter && !!voteOptions?.requestFilter?.competitionId && !disableRequest), [voteOptions?.requestFilter, disableRequest ])
    const isCanSetVote = useMemo(
      () => (
        voteOptions?.currentList?.length === voteOptions?.criteriaList?.length &&
        (voteOptions?.currentList?.every((i: any) => i?.voteValue !== -1) && voteOptions?.criteriaList?.every((i: any) => i?.voteValue !== -1)) && 
        voteOptions?.criteriaList?.length > 0 && 
        !voteOptions.voiceSet && !voteOptions?.isLoading
      ) 
    , [
      voteOptions.currentList,
      voteOptions.voiceSet, 
      voteOptions?.criteriaList, 
      voteOptions?.isLoading
    ])
    const isCanFetchNextVote = useMemo(
      () => voteOptions.nextCriteriaId !== '' && !!voteOptions?.requestFilter?.competitionId && !disableNextVoteRequest && voteOptions.nextCriteriaId !== voteOptions?.requestFilter?.projectId, [voteOptions.nextCriteriaId, voteOptions?.requestFilter, disableNextVoteRequest ])
    const isCanUpdateNextCrt = useMemo(
      () => voteOptions.nextCriteriaId === voteOptions?.requestFilter?.projectId, [voteOptions.nextCriteriaId , voteOptions?.requestFilter ])
    const isCanSetEndVoteStatus = useMemo(() => {
      if (voteOptions) {
        const {
          isLoading,
          nextCriteriaId,
          requestFilter,
          criteriaList
        } = voteOptions;
        const { competitionId = '' } = requestFilter || { competitionId: ' '};
        const hasVote = !!criteriaList?.length && criteriaList?.every?.((i: any) => i?.voteValue !== -1); 

        return !isLoading && nextCriteriaId === '' && competitionId !== '' && hasVote;
      }
    }  
    , [
      voteOptions?.nextCriteriaId, 
      voteOptions?.isLoading, 
      voteOptions?.requestFilter, 
      voteOptions?.criteriaList
    ])

    const updateVotedStatus = useCallback(() => {

      if (!!isCanSetEndVoteStatus) {
        dispatch(setVoteStatus(PROJECT_VOTE_STATUS.end))
      }
    }, [
      dispatch, 
      voteOptions,
      voteOptions?.criteriaList, 
      voteOptions.requestFilter, 
      isCanSetEndVoteStatus, 
      voteOptions.nextCriteriaId,
    ])

    useEffect(() => {
      if (isCanUpdateNextCrt) {
        dispatch(receiveVoteDataList({
          data: voteOptions?.nextCriteriaList?.reduce(
            (acc: any, a: any) => ([...acc, {...a }]
          ) , [])
        }));
        return;
      }
    } , [
      voteOptions.nextCriteriaList, 
      voteOptions.nextCriteriaId, 
      isCanUpdateNextCrt 
    ])

    useEffect(() => {
      if (!!isCanFetchVotes) {
        fetchVotes({
          ...voteOptions?.requestFilter, 
          ...requestOpt((val) => setDisableRequest(val))
        })
      }

      return () => {
        dispatch(resetVoteDataList())
      }
    }, [voteOptions.criteriaList, voteOptions.requestFilter, i18n, isCanFetchVotes])

    useEffect(() => {
      if (isCanSetVote) {
        fetchUpdateVote(voteOptions.currentList, dispatch);
        dispatch(resetUpdateVote());
      }
    }, [isCanSetVote, voteOptions.currentList])

    useEffect(() => {
      if (isCanFetchNextVote) {
        fetchNextVote({ 
          ...voteOptions.requestFilter,
          projectId: voteOptions.nextCriteriaId,
          ...requestOpt((val) => setDisableNextVoteRequest(val))
        })
      }
    } , [
      isCanFetchNextVote,
      voteOptions.nextCriteriaId, 
      voteOptions.requestFilter,
    ])

    useEffect(() => {
      let int = setTimeout(updateVotedStatus, 2000)

      return () => {
        clearTimeout(int)
      }
    }, [
      updateVotedStatus,
    ])

  const setFilter = useCallback((data: RequestFilterT) => {
    const isEqual = JSON.stringify(data) === JSON.stringify(voteOptions?.requestFilter);

    if (!isEqual) {
      dispatch(updateRequestFilter(data))
    } 
  }, [voteOptions])

  const setVote = useCallback((data: Record<string, any>[]) => {
    dispatch(updateCurrentVote(data))
  }, [])

  const onUpdateModalStorage = (data: string) => {
    let current = localStorage.getItem('showedVoteModal');
    
    current = current ? JSON.parse(JSON.stringify(current)) : [];

    if (!Array.isArray(current)) {
      //@ts-ignore
      current = [...JSON.parse(current)]
    }

    if (current?.includes(data)) return;
    //@ts-ignore
    localStorage.setItem('showedVoteModal', JSON.stringify([...current, data]))
  }

  const onToggleStatus = useCallback(() => {
    onUpdateModalStorage(voteOptions.requestFilter?.competitionId)
    dispatch(setVoteStatus(PROJECT_VOTE_STATUS.continue))
  }, [dispatch, voteOptions.requestFilter])

  const updateData= useCallback(() => {
    dispatch(updateVoteData())
    setDisableNextRequest(false);
    setDisableNextVoteRequest(false);
    setDisableRequest(false);
  }, [])

  const resetData= useCallback(() => {
    dispatch(resetVoteData())
    setDisableNextVoteRequest(false);
    setDisableNextRequest(false);
    setDisableRequest(false);
  }, [])

    return (
      <VoteContext.Provider 
        value={{ 
          ...voteOptions,
          onToggleStatus,
          setFilter,
          updateData,
          resetData,
          setVote
          }
        }
      >
        {children}
      </VoteContext.Provider>
    );
  }

  export function useVoteContest() {
    return useContext(VoteContext);
}

  import { useEffect, useReducer, FC, useCallback, useState, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FETCH_VOTE_DATA_LIST_SUCCESS, FETCH_VOTE_DATA_LIST_REQUEST, FETCH_VOTE_DATA_LIST_FAILURE, UPDATE_VOTE_SUCCESS, UPDATE_VOTE_REQUEST, UPDATE_VOTE_FAILURE, requestVoteDataList, receiveVoteDataList, errorVoteDataList, resetVoteDataList, requestUpdateVote, receiveUpdateVote, errorUpdateVote, resetUpdateVote, requestGetNext, errorGetNext, receiveGetNext, GET_NEXT_SUCCESS, setVoteStatus, updateRequestFilter, updateCurrentVote, RESET_VOTE_DATA, resetVoteData, SET_CURRENT_VOTE, UPDATE_REQUEST_FILTER, requestCompetitions, errorCompetitions, receiveCompetitions, FETCH_COMPETITIONS_REQUEST, FETCH_COMPETITIONS_SUCCESS, FETCH_COMPETITIONS_FAILURE, RESET_UPDATE_VOTE, setPrevCrt, VOICE_SET, SET_PREV_CRITERIA, VOTE_END,  fetchNextVote, GET_NEXT_DATA_REQUEST, GET_NEXT_DATA_SUCCESS, GET_NEXT_DATA_FAILURE, fetchVotes, UPDATE_VOTE_DATA, updateVoteData, fetchUpdateVote } from "shared/actions/Vote/voteActions";
import VoteContext, { RequestFilterT, initialContext } from "shared/contexts/VoteContext";

  export const PROJECT_VOTE_STATUS = {
    end: 'end',
    continue: 'continue',
    inProgress: 'inProgress'
  }

  type PropsT = {
    children: any;
  }
  
  export const VoteProvider: FC<PropsT> = ({ children }) => {
    const {i18n} = useTranslation();
    const [disableRequest, setDisableRequest] = useState(false);
    const [disableNextRequest, setDisableNextRequest] = useState(false);
    const [disableNextVoteRequest, setDisableNextVoteRequest] = useState(false);
    const [voteOptions, dispatch] = useReducer((state: any, action: any) => {
      switch (action.type) {
        case FETCH_VOTE_DATA_LIST_SUCCESS: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_VOTE_DATA_LIST_FAILURE:{
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_VOTE_DATA_LIST_REQUEST: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_COMPETITIONS_REQUEST: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_COMPETITIONS_SUCCESS:{
          return {
            ...state,
            ...action.payload,
          }
        }
        case FETCH_COMPETITIONS_FAILURE: {
          return {
            ...state,
            ...action.payload,
          }
        }

        case UPDATE_VOTE_SUCCESS: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case UPDATE_VOTE_REQUEST: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case UPDATE_VOTE_FAILURE: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case RESET_UPDATE_VOTE: {
          return {
            ...state,
            ...action.payload
          }
        }
        case GET_NEXT_SUCCESS: {
          return {
            ...state,
            ...action.payload,
          }
        }
        case GET_NEXT_DATA_REQUEST: {
          return {
            ...state,
            ...action.payload
          }
        }
        case GET_NEXT_DATA_SUCCESS: {
          return {
            ...state,
            ...action.payload
          }
        }
        case GET_NEXT_DATA_FAILURE: {
          return {
            ...state,
            ...action.payload
          }
        }
        case UPDATE_REQUEST_FILTER: {
          return {
            ...state,
            requestFilter: action.payload
          }
        }
        case SET_CURRENT_VOTE: {
          return {
            ...state,
            ...action.payload
          }
        }
        case RESET_VOTE_DATA: {
          return {initialContext}
        }
        case UPDATE_VOTE_DATA: {
          return {
            ...state,
            requestFilter: undefined,
            currentList: [],
          }
        }
        case VOICE_SET: {
          return {
            ...state,
            voiceSet: action.payload
          }
        }
        case SET_PREV_CRITERIA: {
          return {
            ...state,
            ...action.payload
          }
        }
        case VOTE_END: {
          return { 
            ...state,
            ...action.payload
          }
        }
        default:
          return state;
      }
    }
      ,{...initialContext});

    const requestOpt = (additionalOpt: (val: boolean) => void) => ({ callback: additionalOpt, dispatch })

    const isCanFetchVotes = useMemo(
      () => (voteOptions?.requestFilter && !!voteOptions?.requestFilter?.competitionId && !disableRequest), [voteOptions?.requestFilter, disableRequest ])
    const isCanSetVote = useMemo(
      () => (
        voteOptions?.currentList?.length === voteOptions?.criteriaList?.length &&
        (voteOptions?.currentList?.every((i: any) => i?.voteValue !== -1) && voteOptions?.criteriaList?.every((i: any) => i?.voteValue !== -1)) && 
        voteOptions?.criteriaList?.length > 0 && 
        !voteOptions.voiceSet && !voteOptions?.isLoading
      ) 
    , [
      voteOptions.currentList,
      voteOptions.voiceSet, 
      voteOptions?.criteriaList, 
      voteOptions?.isLoading
    ])
    const isCanFetchNextVote = useMemo(
      () => voteOptions.nextCriteriaId !== '' && !!voteOptions?.requestFilter?.competitionId && !disableNextVoteRequest && voteOptions.nextCriteriaId !== voteOptions?.requestFilter?.projectId, [voteOptions.nextCriteriaId, voteOptions?.requestFilter, disableNextVoteRequest ])
    const isCanUpdateNextCrt = useMemo(
      () => voteOptions.nextCriteriaId === voteOptions?.requestFilter?.projectId, [voteOptions.nextCriteriaId , voteOptions?.requestFilter ])
    const isCanSetEndVoteStatus = useMemo(() => {
      if (voteOptions) {
        const {
          isLoading,
          nextCriteriaId,
          requestFilter,
          criteriaList
        } = voteOptions;
        const { competitionId = '' } = requestFilter || { competitionId: ' '};
        const hasVote = !!criteriaList?.length && criteriaList?.every?.((i: any) => i?.voteValue !== -1); 

        return !isLoading && nextCriteriaId === '' && competitionId !== '' && hasVote;
      }
    }  
    , [
      voteOptions?.nextCriteriaId, 
      voteOptions?.isLoading, 
      voteOptions?.requestFilter, 
      voteOptions?.criteriaList
    ])

    const updateVotedStatus = useCallback(() => {

      if (!!isCanSetEndVoteStatus) {
        dispatch(setVoteStatus(PROJECT_VOTE_STATUS.end))
      }
    }, [
      dispatch, 
      voteOptions,
      voteOptions?.criteriaList, 
      voteOptions.requestFilter, 
      isCanSetEndVoteStatus, 
      voteOptions.nextCriteriaId,
    ])

    useEffect(() => {
      if (isCanUpdateNextCrt) {
        dispatch(receiveVoteDataList({
          data: voteOptions?.nextCriteriaList?.reduce(
            (acc: any, a: any) => ([...acc, {...a }]
          ) , [])
        }));
        return;
      }
    } , [
      voteOptions.nextCriteriaList, 
      voteOptions.nextCriteriaId, 
      isCanUpdateNextCrt 
    ])

    useEffect(() => {
      if (!!isCanFetchVotes) {
        fetchVotes({
          ...voteOptions?.requestFilter, 
          ...requestOpt((val) => setDisableRequest(val))
        })
      }

      return () => {
        dispatch(resetVoteDataList())
      }
    }, [voteOptions.criteriaList, voteOptions.requestFilter, i18n, isCanFetchVotes])

    useEffect(() => {
      if (isCanSetVote) {
        fetchUpdateVote(voteOptions.currentList, dispatch);
        dispatch(resetUpdateVote());
      }
    }, [isCanSetVote, voteOptions.currentList])

    useEffect(() => {
      if (isCanFetchNextVote) {
        fetchNextVote({ 
          ...voteOptions.requestFilter,
          projectId: voteOptions.nextCriteriaId,
          ...requestOpt((val) => setDisableNextVoteRequest(val))
        })
      }
    } , [
      isCanFetchNextVote,
      voteOptions.nextCriteriaId, 
      voteOptions.requestFilter,
    ])

    useEffect(() => {
      let int = setTimeout(updateVotedStatus, 2000)

      return () => {
        clearTimeout(int)
      }
    }, [
      updateVotedStatus,
    ])

  const setFilter = useCallback((data: RequestFilterT) => {
    const isEqual = JSON.stringify(data) === JSON.stringify(voteOptions?.requestFilter);

    if (!isEqual) {
      dispatch(updateRequestFilter(data))
    } 
  }, [voteOptions])

  const setVote = useCallback((data: Record<string, any>[]) => {
    dispatch(updateCurrentVote(data))
  }, [])

  const onUpdateModalStorage = (data: string) => {
    let current = localStorage.getItem('showedVoteModal');
    
    current = current ? JSON.parse(JSON.stringify(current)) : [];

    if (!Array.isArray(current)) {
      //@ts-ignore
      current = [...JSON.parse(current)]
    }

    if (current?.includes(data)) return;
    //@ts-ignore
    localStorage.setItem('showedVoteModal', JSON.stringify([...current, data]))
  }

  const onToggleStatus = useCallback(() => {
    onUpdateModalStorage(voteOptions.requestFilter?.competitionId)
    dispatch(setVoteStatus(PROJECT_VOTE_STATUS.continue))
  }, [dispatch, voteOptions.requestFilter])

  const updateData= useCallback(() => {
    dispatch(updateVoteData())
    setDisableNextRequest(false);
    setDisableNextVoteRequest(false);
    setDisableRequest(false);
  }, [])

  const resetData= useCallback(() => {
    dispatch(resetVoteData())
    setDisableNextVoteRequest(false);
    setDisableNextRequest(false);
    setDisableRequest(false);
  }, [])

    return (
      <VoteContext.Provider 
        value={{ 
          ...voteOptions,
          onToggleStatus,
          setFilter,
          updateData,
          resetData,
          setVote
          }
        }
      >
        {children}
      </VoteContext.Provider>
    );
  }

  export function useVoteContest() {
    return useContext(VoteContext);
}

  